import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import ForgotPassword from "screens/ForgotPassword/ForgotPassword";
import Login from "screens/Login/Login";
import Register from "screens/Register/Register";
import { LoginFlowStackParamList } from "./types";
import ResetPassword from "screens/ResetPassword/ResetPassword";
const LoginStack = createNativeStackNavigator<LoginFlowStackParamList>();

export default function LoginFlowStack() {
  return (
    <LoginStack.Navigator screenOptions={{ headerShown: false }}>
      <LoginStack.Screen
        name="Login"
        component={Login}
        options={{ title: "Login" }}
      ></LoginStack.Screen>
      <LoginStack.Screen
        name="Register"
        component={Register}
        options={{ title: "Register" }}
      ></LoginStack.Screen>
      <LoginStack.Screen
        name="ForgotPassword"
        component={ForgotPassword}
        options={{ title: "Forgot Password" }}
      ></LoginStack.Screen>
      <LoginStack.Screen
        name="ResetPassword"
        component={ResetPassword}
        options={{ title: "Reset Password" }}
      ></LoginStack.Screen>
    </LoginStack.Navigator>
  );
}
